import React, { useState,useEffect } from 'react';
import { toast } from 'react-toastify';
import {format, parseISO } from 'date-fns';
import { getDefaultReviewList,getSingleReviewTemplateDetail,searchAliExpressReview } from "../../../../utils/reviewApi";
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import RatingStars from "../../../../components/RatingStars";

const BadgeWidget = ({selectedLayout,isTemplateId, widgetId,reviewTabData,searchedKeyword}) => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [expandedReviewId, setExpandedReviewId] = useState(null);

  // Default values for the reviewTabData
  const {
      is_website_frontend,
      business_name,
      style_background_color,
      header_is_widget_title,
      header_title,
      header_caption,
      setting_rating_format,
      style_widget_title_color,
      style_widget_title_fonts_title_size,
      style_widget_title_caption_color,
      style_widget_title_fonts_caption_size,
      style_header_background_color,
      header_is_show_header,
      header_write_reviews_button,
      header_source_icon,
      header_rating,
      header_number_of_reviews,
      style_header_text_color,
      style_header_write_review_background_color,
      style_header_write_review_text_color,
      header_write_review_button_type,
      style_rating_stars_color,
      style_load_more_button_color,
      style_load_more_button_text_color,
  } = reviewTabData || {};

  //Handle when clicking "Read More"
  const handleReadMoreClick = (review) => {
    setExpandedReviewId(prev =>
      prev === review.id ? null : review.id
    );
  };

  //Handle Main Popup
  const togglePopup = () => {
      setShowPopup(!showPopup);
  };

  // Load More function
  const handleLoadMore = () => {
      setVisibleCount((prevCount) => prevCount + 5);
  };

  // Fetching Review data
  useEffect(() => {
      const fetchData = async () => {
          setLoading(true);
          try {
              let result;
              if (isTemplateId) {
                  result = await getSingleReviewTemplateDetail(isTemplateId);
              } else if (widgetId) {
                  result = await getSingleWidgetDetail(widgetId);
              } else if (business_name) {
                const payload = { business_name: business_name };
                result = await searchAliExpressReview(payload);
              } else {
                  let app_type = 'AliExpress_Review';
                  result = await getDefaultReviewList(app_type);
              }
              setApiData(result);
          } catch (error) {
              toast.warning(error.message);
          } finally {
              setLoading(false); 
          }
      };

      fetchData();
  }, [isTemplateId, widgetId, business_name]);
  return (
   <>
    <div className={`upgadeify-review-template-widget upgadeify-badge-style ${showPopup ? 'main-popup-open' : ''} ${is_website_frontend}`}>
        {/* Loader and No Api Data Handling */}
        {loading ? (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading please wait...</p>
            </div>
        ) : apiData?.status === true ? (
        <>
          <div className='upgadeify-badge-style-header' onClick={togglePopup}>
            <div className='upgadeify-badge-header-title'>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><path fill="#FF8F00" d="M19.372 19.922H4.488A1.462 1.462 0 0 1 3 18.433V4.988C3 4.145 3.645 3.5 4.488 3.5h14.884c.843 0 1.488.645 1.488 1.488v13.445c0 .794-.645 1.489-1.488 1.489Z"></path><path fill="#DD2C00" d="M19.372 21.36H4.488A1.462 1.462 0 0 1 3 19.872V7.47c0-.843.645-1.488 1.488-1.488h14.884c.843 0 1.488.645 1.488 1.488v12.403c0 .844-.645 1.488-1.488 1.488Z"></path><path fill="#B71C1C" d="M7.465 7.965a.992.992 0 1 0 0 1.985.992.992 0 0 0 0-1.985Zm8.93 0a.992.992 0 1 0 0 1.985.992.992 0 0 0 0-1.985Z"></path><path fill="#fff" d="M11.93 13.919a4.976 4.976 0 0 1-4.96-4.962c0-.297.198-.496.496-.496s.496.199.496.496a3.98 3.98 0 0 0 3.97 3.97 3.98 3.98 0 0 0 3.968-3.97c0-.297.199-.496.496-.496.298 0 .497.199.497.496a4.976 4.976 0 0 1-4.962 4.962Z"></path></svg>


              <div className='upgadeify-badge-reviews-header-title-text'>AliExpress Rating</div>
            </div>
            <div className='upgadeify-aliexpress-reviews-header-rating'>
              <div className="upgadeify-aliexpress-reviews-header-rating-text">{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
              <div className="upgadeify-aliexpress-reviews-item-rating">
                <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
              </div>
            </div>
            <div className="upgadeify-badge-reviews-readmore">
              Read our { apiData.data.total_reviews }  reviews
            </div>
          </div>
        </>
          ) : (
              <div className="no-inner-result-found">
                  <p>No Aliexpress reviews found please check the product number.</p>
              </div>
          )}
        </div>
    
        {showPopup && (
        <div className="upgadeify-badge-fixed-style">
          <div className="upgadeify-badge-style-inner" style={{backgroundColor: style_background_color}}>
              <button className="upgadeify-badge-fixed-style-close" onClick={togglePopup}>X</button>
              {Number(header_is_widget_title) === 1 && (
                <>
                  <div className="upgadeify-badge-fixed-style-title">
                      <h2 style={{ color: style_widget_title_color,fontSize: style_widget_title_fonts_title_size }}>{header_title || ""}</h2>
                      <h2 style={{ color: style_widget_title_caption_color,fontSize: style_widget_title_fonts_caption_size }}>{header_caption || ""}</h2>
                  </div>
                </>
              )}
              {Number(header_is_show_header) === 1 &&
                (Number(header_source_icon) === 1 ||
                    Number(header_rating) === 1 ||
                    Number(header_number_of_reviews) === 1 ||
                    Number(header_write_reviews_button) === 1) && (
               <div className="upgadeify-badge-fixed-style-header" style={{ backgroundColor: style_header_background_color,}}>
                    <div className='upgadeify-aliexpress-reviews-header-left'>
                      {Number(header_source_icon) === 1 && (
                        <div className='upgadeify-aliexpress-reviews-header-title'>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 36" fill="none" className="injected-svg"><g fill-rule="evenodd" clip-path="url(#clip0_1_2)" clip-rule="evenodd">
                          <path fill="#D1332C" d="M22.919 24.798V10.612h8.372V12.4h-6.635v4.36h5.954v1.786h-5.954v4.466h7.124v1.787h-8.861Zm17.679 0-2.892-3.786-2.872 3.786h-2.041l3.934-5.062-4.147-5.21h2.276l2.85 3.913 2.871-3.914h2.254l-3.934 5.211 3.743 5.062h-2.042Zm12.103-5.147c0-2.276-1.462-3.652-4.094-3.528-1.253.059-3.216.975-3.03 4.245.06 1.049 1.143 3.065 3.542 3.065 2.063 0 3.582-1.196 3.582-3.782Zm-7.254 3.594v6.994h-1.758V19.774c0-2.658 2.047-5.504 5.224-5.504 3.203 0 5.636 2.042 5.636 5.381 0 3.277-2.446 5.51-5.237 5.51-1.404 0-3.212-.585-3.865-1.916Zm10.569 1.553V14.526h1.718v1.092c.842-.957 2.15-1.327 3.553-1.327v1.872c-.19-.021-2.273-.28-3.553 2.406v6.229h-1.718Zm10.694-8.799c-1.672 0-2.932 1.44-3.017 2.993h6.316c-.02-1.51-1.107-2.993-3.299-2.993Zm-4.91 3.652c0-2.977 2.127-5.38 5.062-5.38 3.64 0 5.006 2.424 5.006 5.508v.83h-8.154c.128 1.934 1.862 2.957 3.467 2.913 1.19-.033 1.999-.399 2.828-1.25l1.127 1.186c-1.041 1.02-2.424 1.703-4.083 1.703-3.062 0-5.253-2.299-5.253-5.51Zm10.905 3.703 1.276-1.13c-.024.021.644.68.713.738.287.238.613.414.974.51 1.107.292 3.105.197 3.244-1.302.08-.856-.565-1.323-1.281-1.59-.944-.352-1.959-.481-2.884-.888-1.05-.462-1.723-1.285-1.723-2.466 0-3.09 4.388-3.604 6.381-2.158.105.075 1.078.956 1.036.988l-1.29.997c-.616-.744-1.248-1.135-2.588-1.156-.663-.01-1.604.279-1.797 1.013-.268 1.018.897 1.404 1.651 1.599 1.017.263 2.112.41 3.018.977 1.211.76 1.528 2.403 1.05 3.684-.516 1.385-2.014 1.929-3.385 1.992-1.613.075-2.998-.442-4.16-1.572l-.235-.236Zm8.942 0 1.276-1.13c-.024.021.644.68.713.738.287.238.613.414.974.51 1.107.292 3.106.197 3.245-1.302.079-.856-.566-1.323-1.282-1.59-.944-.352-1.958-.481-2.884-.888-1.05-.462-1.723-1.285-1.723-2.466 0-3.09 4.388-3.604 6.382-2.158.104.075 1.077.956 1.035.988l-1.29.997c-.616-.744-1.248-1.135-2.588-1.156-.663-.01-1.604.279-1.797 1.013-.268 1.018.898 1.404 1.651 1.599 1.017.263 2.112.41 3.018.977 1.211.76 1.528 2.403 1.05 3.684-.515 1.385-2.014 1.929-3.384 1.992-1.613.075-2.998-.442-4.161-1.572l-.235-.236Z"></path>
                          <path fill="#EB9030" d="M6.38 12.633 3.807 19.65h5.38L6.38 12.633Zm4.786 12.165L9.91 21.416H3.063l-1.255 3.382H0l5.508-14.186h1.978l5.487 14.186h-1.807Zm2.866 0h1.762V10.612h-1.762v14.186Zm4.439 0h1.763V14.74h-1.763v10.057Zm3.489-13.334c.001-.03.005-.06.005-.09 0-.031-.004-.06-.005-.09a2.608 2.608 0 0 1-2.5-2.517c-.035-.002-.07-.006-.107-.006-.037 0-.073.004-.109.006a2.608 2.608 0 0 1-2.499 2.516c0 .03-.004.06-.004.09 0 .031.003.06.004.09a2.608 2.608 0 0 1 2.5 2.517c.035.002.071.005.108.005.036 0 .072-.003.108-.005a2.608 2.608 0 0 1 2.5-2.516Z"></path></g><defs><clipPath id="clip0_1_2"><rect width="89.64" height="36" fill="#fff"></rect></clipPath></defs></svg>
                              <div className='upgadeify-aliexpress-reviews-header-title-text' style={{color: style_header_text_color,}}>Reviews</div>
                        </div>
                        )}
                        <div className='upgadeify-aliexpress-reviews-header-rating'>
                          {Number(header_rating) === 1 && (
                          <>
                              <div className="upgadeify-aliexpress-reviews-header-rating-text" style={{color: style_header_text_color,}}>{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
                              <div className="upgadeify-aliexpress-reviews-item-rating">
                                  <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
                              </div>
                          </>
                          )}
                          {Number(header_number_of_reviews) === 1 && (
                              <span className="upgadeify-aliexpress-reviews-header-number-of-reviews-text">({apiData.data.total_reviews})</span>
                          )}
                        </div>
                    </div>
                    {Number(header_write_reviews_button) === 1 && (
                        <div className='upgadeify-aliexpress-reviews-header-right'>
                            <a
                                href={apiData?.data?.google_url?.startsWith('http') ? apiData.data.google_url : `https://${apiData.data.google_url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className='upgadeify-aliexpress-reviews-header-button'
                                style={{color: style_header_write_review_text_color,backgroundColor: style_header_write_review_background_color,fontSize: header_write_review_button_type}}>Review us on AliExpress
                            </a>
                        </div>
                    )}
                </div>
              )}
              {/* Reviews List */}
              {apiData.data.review_list.slice(0, visibleCount).map((review) => (
                  <ReviewLoopItem key={review.id} review={review} handleReadMoreClick={handleReadMoreClick} reviewTabData={reviewTabData} expandedReviewId={expandedReviewId}/>
              ))}
              {/* Load More Button  */}
              {visibleCount < apiData.data.review_list.length && (
                <div className="load-more-button">
                    <button onClick={handleLoadMore} style={{backgroundColor: style_load_more_button_color,color: style_load_more_button_text_color}}>Load More</button>
                </div>
              )}
          </div>
        </div>
      )}
   </>
  );
};

const ReviewLoopItem = ({ review, handleReadMoreClick, reviewTabData, expandedReviewId }) => (
    <>
        <div className="upgadeify-aliexpress-reviews">
            <div className='upgadeify-aliexpress-reviews-item' style={{ padding: `${reviewTabData.layout_item_spacing}px`, backgroundColor: reviewTabData.style_review_background_color,}}>
               <div className='upgadeify-aaliexpressazon-reviews-head'>
                {Number(reviewTabData.review_is_show_reviewer_picture) === 1 && (
                    <div className="upgadeify-aliexpress-reviews-item-image">
                        {review.image ? (
                            <img src={review.image} alt="Review" />
                        ) : (
                            <div className="fallback-avatar">
                                {review.name.charAt(0)}
                            </div>
                        )}
                    </div>
                )}
                <div className='upgadeify-aliexpress-reviews-item-name'>
                    {Number(reviewTabData.review_is_show_reviewer_name) === 1 && (
                        Number(reviewTabData.setting_is_enable_external_links) === 1 && review.author_url ? ( 
                            <a
                                href={review.author_url} 
                                target={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "_blank" : "_self"}
                                rel={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "noopener noreferrer" : undefined}
                                style={{ color: reviewTabData.style_review_reviewer_name_color }}
                            >
                                <span className="upgadeify-aliexpress-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>{review.name}</span>
                            </a>
                        ) : (
                            <span className="upgadeify-aliexpress-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>
                                {review.name}
                            </span>
                        )
                    )}

                    {Number(reviewTabData.review_is_show_verified_badge) === 1 && (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="review-verified-badge-icon" aria-hidden="true">
                            <path fill={reviewTabData.style_review_verified_badge_color} d="M6.757.236a.35.35 0 0 1 .486 0l1.106 1.07a.35.35 0 0 0 .329.089l1.493-.375a.35.35 0 0 1 .422.244l.422 1.48a.35.35 0 0 0 .24.24l1.481.423a.35.35 0 0 1 .244.422l-.375 1.493a.35.35 0 0 0 .088.329l1.071 1.106a.35.35 0 0 1 0 .486l-1.07 1.106a.35.35 0 0 0-.089.329l.375 1.493a.35.35 0 0 1-.244.422l-1.48.422a.35.35 0 0 0-.24.24l-.423 1.481a.35.35 0 0 1-.422.244l-1.493-.375a.35.35 0 0 0-.329.088l-1.106 1.071a.35.35 0 0 1-.486 0l-1.106-1.07a.35.35 0 0 0-.329-.089l-1.493.375a.35.35 0 0 1-.422-.244l-.422-1.48a.35.35 0 0 0-.24-.24l-1.481-.423a.35.35 0 0 1-.244-.422l.375-1.493a.35.35 0 0 0-.088-.329L.236 7.243a.35.35 0 0 1 0-.486l1.07-1.106a.35.35 0 0 0 .089-.329L1.02 3.829a.35.35 0 0 1 .244-.422l1.48-.422a.35.35 0 0 0 .24-.24l.423-1.481a.35.35 0 0 1 .422-.244l1.493.375a.35.35 0 0 0 .329-.088L6.757.236Z"></path><path fill="#fff" fill-rule="evenodd" d="M9.065 4.85a.644.644 0 0 1 .899 0 .615.615 0 0 1 .053.823l-.053.059L6.48 9.15a.645.645 0 0 1-.84.052l-.06-.052-1.66-1.527a.616.616 0 0 1 0-.882.645.645 0 0 1 .84-.052l.06.052 1.21 1.086 3.034-2.978Z" clip-rule="evenodd"></path>
                        </svg>
                    )}

                    <span className="upgadeify-aliexpress-reviews-item-date"> 
                        {Number(reviewTabData.review_is_show_date) === 1 && (
                            <span style={{color: reviewTabData.style_review_date_color,}}>{review.review_date ? format(parseISO(review.review_date), 'yyyy-MM-dd') : ''}</span>
                        )}
                    </span>
                </div>
               </div>
                <div className="upgadeify-aliexpress-reviews-item-content">
                    {Number(reviewTabData.review_is_show_rating) === 1 && (
                        <span className="upgadeify-aliexpress-reviews-item-rating" style={{ fontSize: reviewTabData.style_review_rating_size }}>
                            <RatingStars average_rating={review.rating} newColor={reviewTabData.style_rating_stars_color}/>
                        </span>
                    )}
                    <div className="upgadeify-aliexpress-reviews-item-text" style={{color: `${reviewTabData.style_review_text_color}`,fontSize: reviewTabData.style_review_text_font_size}}>
                        {expandedReviewId === review.id ? review.description: review.description.length > 50
                            ? `${review.description.slice(0, 50)}...`
                            : review.description
                        }
                    </div>
                    {review.description.length > 50 && (
                      <div className="upgadeify-aliexpress-reviews-readmore" onClick={() => handleReadMoreClick(review)}
                        style={{
                          color: reviewTabData.style_read_more_color,
                          fontSize: reviewTabData.style_review_text_font_size
                        }}
                      >
                        {expandedReviewId === review.id ? 'Read less' : 'Read more'}
                      </div>
                    )}

                    {Number(reviewTabData.review_is_show_review_source) === 1 && (  
                        <div className='upgadeify-aliexpress-reviews-item-image-badge'>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><path fill="#fff" stroke="#fff" strokeLinejoin="round" strokeWidth="2" d="M4.5 22.5h15c1.5 0 2.5-1.312 2.5-2.631V5.13c0-1.395-1.02-2.63-2.5-2.63h-15C3.02 2.5 2 3.735 2 5.131V19.87c0 1.395 1.02 2.63 2.5 2.63Z"></path><path fill="#FF8F00" d="M19.5 21.5h-15c-.85 0-1.5-.707-1.5-1.631V5.13c0-.923.65-1.63 1.5-1.63h15c.85 0 1.5.707 1.5 1.631V19.87c0 .87-.65 1.631-1.5 1.631Z"></path><path fill="#DD2C00" d="M19.5 21.5h-15c-.85 0-1.5-.671-1.5-1.548V7.048C3 6.171 3.65 5.5 4.5 5.5h15c.85 0 1.5.671 1.5 1.548v12.904c0 .877-.65 1.548-1.5 1.548Z"></path><path fill="#B71C1C" d="M7.465 7.965a.992.992 0 1 0 0 1.985.992.992 0 0 0 0-1.985Zm8.93 0a.992.992 0 1 0 0 1.985.992.992 0 0 0 0-1.985Z"></path><path fill="#fff" d="M11.93 13.919a4.976 4.976 0 0 1-4.96-4.962c0-.297.198-.496.496-.496s.496.199.496.496a3.98 3.98 0 0 0 3.97 3.97 3.98 3.98 0 0 0 3.968-3.97c0-.297.199-.496.496-.496.298 0 .497.199.497.496a4.976 4.976 0 0 1-4.962 4.962Z"></path></svg>
                            Posted On   
                            <> <a href={`https://www.aliexpress.com/item/${review.review_id}.html`} target="blank">AliExpress</a></> 
                        </div> 
                    )}  
                </div>
            </div>
        </div>
    </>
);

export default BadgeWidget;
